/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ── Variant button updater ────────────────────────────────────────────────
  // product-info.js only ever updates the first (mobile) product-form.
  // This ensures ALL add-to-cart buttons (mobile + desktop) show the correct
  // "Add to cart" / "Sold out" state whenever a variant option is selected.
  function initVariantButtonUpdater() {
    document.querySelectorAll('product-info[data-section]').forEach(function(productInfo) {
      var sectionId = productInfo.dataset.section;
      var variantsEl = productInfo.querySelector('[data-product-variants-json]');
      if (!variantsEl) return;

      var variants;
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

      var lastVariant = null; // last correctly identified variant from user selection

      function getOptionsFrom(vs) {
        var opts = [];
        vs.querySelectorAll('fieldset').forEach(function(fs) {
          var checked = fs.querySelector('input:checked');
          if (checked) opts.push(checked.value);
        });
        if (!opts.length) {
          vs.querySelectorAll('[data-popout-input]').forEach(function(inp) {
            if (inp.value) opts.push(inp.value);
          });
        }
        return opts;
      }

      function findVariant(opts) {
        if (!opts.length) return null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < opts.length; j++) {
            if (v.options[j] !== opts[j]) { match = false; break; }
          }
          if (match) return v;
        }
        return null;
      }

      function applyVariant(variant) {
        // Update every add-to-cart button (handles both mobile & desktop forms)
        productInfo.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
          var btnText = btn.querySelector('[data-add-to-cart-text]');
          if (!btnText) return;

          var priceEl   = btnText.querySelector('[data-product-price]');
          var priceHTML = priceEl ? priceEl.outerHTML : '';

          if (!variant) {
            btn.setAttribute('disabled', 'disabled');
            btnText.textContent = (window.theme.strings && window.theme.strings.unavailable) || 'Unavailable';
          } else if (variant.available) {
            btn.removeAttribute('disabled');
            btnText.textContent = (window.theme.strings && window.theme.strings.addToCart) || 'Add to cart';
          } else {
            btn.setAttribute('disabled', 'disabled');
            btnText.textContent = (window.theme.strings && window.theme.strings.soldOut) || 'Sold out';
          }

          if (priceHTML) btnText.insertAdjacentHTML('beforeend', ' ' + priceHTML);
        });

        // Keep the hidden variant-id inputs in sync so the form submits the right variant
        if (variant) {
          productInfo.querySelectorAll('.product-variant-id').forEach(function(inp) {
            inp.value    = variant.id;
            inp.disabled = !variant.available;
          });
        }
      }

      if (!window.subscribe || !window.theme || !window.theme.PUB_SUB_EVENTS) return;

      // 1) Immediate update the moment a variant option is changed (before the async fetch)
      window.subscribe(window.theme.PUB_SUB_EVENTS.optionValueSelectionChange, function(e) {
        var target = e.data && e.data.event && e.data.event.target;
        if (!target || !productInfo.contains(target)) return;

        var vs = target.closest('variant-selects');
        if (!vs) return;

        lastVariant = findVariant(getOptionsFrom(vs));
        applyVariant(lastVariant);
      });

      // 2) Re-apply after product-info.js finishes its async fetch (which may have
      //    set wrong state if option_values IDs are empty / first-variant fallback)
      window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function(e) {
        if (!e || !e.data || e.data.sectionId !== sectionId) return;
        if (lastVariant !== null) applyVariant(lastVariant);
      });
    });
  }

  if (window.theme && window.theme.PUB_SUB_EVENTS) {
    initVariantButtonUpdater();
  } else {
    document.addEventListener('DOMContentLoaded', initVariantButtonUpdater);
  }
  // ─────────────────────────────────────────────────────────────────────────

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
